import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";

import { useDashboardStore } from "@/stores/useDashboardStore";

import { ApiResources } from "../../../../../api/resources";
import useGetInitialData from "../../../hooks/useGetInitialData";

interface CCStatusProps {
  setMemoiseCCData?: Dispatch<SetStateAction<boolean>>;
  memoiseCCData?: boolean;
}

const useCCstatus = ({ setMemoiseCCData, memoiseCCData }: CCStatusProps) => {
  const { getInitialData } = useGetInitialData();

  const { setCCStatus, setCCStatusError } = useDashboardStore();

  const [isLoading, setIsLoading] = useState<boolean>(!memoiseCCData);

  const initialized = useRef(memoiseCCData || false);

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      setMemoiseCCData?.(true);
      getInitialData({
        setIsLoading,
        setDataState: setCCStatus,
        resource: ApiResources.DashboardCompanyCardsStatus,
        initialized,
        setError: setCCStatusError
      });
    }
  }, [getInitialData, setCCStatus, setCCStatusError, setMemoiseCCData]);

  return { isLoading };
};

export default useCCstatus;
